<mtx-grid
  [columnResizable]="true"
  [columns]="columns"
  [data]="localDocuments"
  [length]="localDocuments.length"
  [rowStriped]="false"
  [noResultText]="'grid.no_results' | translate"
  [rowHover]="false"
  [cellSelectable]="false"
  [showPaginator]="false"
  [pageSize]="localDocuments.length"
  [pageSizeOptions]="[]"
  [columnMenuButtonText]="'grid.columns_shown' | translate"
  [columnHideable]="true"
  [columnHideableChecked]="'show' | translate"
  columnMenuButtonClass="col-button"
  [showSidebar]="true"
  [expandable]="true"
  [expansionTemplate]="expansionTemplate"
  [showToolbar]="true"
  [columnSortable]="true"
  [showColumnMenuButton]="true"
  columnMenuButtonType="flat"
  [columnPinnable]="false">
</mtx-grid>

<ng-template #expansionTemplate let-row>
  @if (row.oldVersions && row.oldVersions.length > 0) {
    <mtx-grid
      [columns]="oldVersionColumns"
      [data]="row.oldVersions"
      [rowStriped]="true"
      [rowHover]="true"
      [cellSelectable]="false"
      [showPaginator]="false"
      [showToolbar]="false"
      [columnSortable]="true"
      style="margin-left: 74px; margin-top: 5px"
      class="hide-header">
    </mtx-grid>
  } @else {
    <div class="expansion-item">
      <ng-container>
        <p class="disabled space-row">
          {{ 'documents.upload_docs.dropdown_message' | translate }}
        </p>
      </ng-container>
    </div>
  }
</ng-template>

<ng-template #documentActionTemplate let-row let-index="index" let-col="colDef">
  <div class="row-button-container">
    <su-button
      *ngIf="col.canUpdate"
      skin="secondary"
      icon="share"
      (onClick)="openUpdateDocumentModal(row)"
      [title]="'documents.tooltip__update' | translate"
      [disabled]="row.actionsDisabled || hideRowActions(row)"
      [ariaLabel]="'documents.tooltip__update' | translate">
    </su-button>
    <su-button
      skin="secondary"
      icon="download"
      (onClick)="downloadDocument($event, row)"
      [title]="'documents.tooltip__download' | translate"
      [disabled]="row.actionsDisabled || hideRowActions(row)"
      [ariaLabel]="'documents.tooltip__download' | translate">
    </su-button>
    <su-button
      *ngIf="canDeleteDocument"
      skin="secondary"
      icon="trash"
      (onClick)="deleteDocument(row)"
      [title]="'documents.tooltip__delete' | translate"
      [ariaLabel]="'documents.tooltip__delete' | translate">
    </su-button>
  </div>
</ng-template>

<app-spinner-overlay [show]="isLoading" [label]="''"></app-spinner-overlay>
